<template>
  <ul class="list-group list-group-flush list my--3">
    <li v-for="item in items" :key="item.id" class="list-group-item px-0">
      <div class="align-items-center">
        <div class="col">
          <h5>{{ item.name }}</h5>
          <p class="m-0">
            {{ item.actions.join(', ') }}
          </p>
        </div>
      </div>
    </li>

    <li v-if="!items.length" class="list-group-item px-0">No posee permisos.</li>
  </ul>
</template>

<script>
export default {
  props: {
    permissions: {
      default: null,
      type: Array,
    },
  },

  data() {
    return {
      items: [],
    };
  },

  created() {
    this.setSections();
  },

  methods: {
    setSections() {
      this.permissions.filter((p) => {
        let included = this.items.some((c) => {
          const exist = c.name.split('.')[0] === p.name.split('.')[0];
          if (exist) {
            c.actions.push(p.action);
          }
          return exist;
        });

        if (!included) {
          const name = p.name.split('.')[0];
          this.items.push({
            id: p.id,
            name,
            actions: [p.action],
          });
        }
      });
    },

    getActionName(action) {
      return action.length === 2 ? action.shift() : action.splice(0, 2).join(' ');
    },
  },
};
</script>
